<template>
  <div ref="Banners" id="Banners">
    <vx-card v-show="bannerListVisable">
      <div>
        <vs-button color="success" class="vx-col mb-4" @click="openAddNewBanner">New Banner</vs-button>
        <vs-table pagination stripe ref="bannerTable" class="vs-con-loading__container" single
          @selected="selectedBanner" :max-items="criteria.pageSize" search :data="banners">
          <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
            <vs-dropdown vs-trigger-click
              class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
              <div
                class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ criteria.pageNumber * criteria.pageSize - (criteria.pageSize - 1) }} - {{
                criteria.pageNumber * criteria.pageSize > 0 ? criteria.pageNumber * criteria.pageSize :
                banners.length }} of {{ banners.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="criteria.pageSize=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            
          </div>
          <template slot="thead">
            <vs-th>Title</vs-th>
            <vs-th>Description</vs-th>
            <vs-th>Active</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="banner" :key="indextr" v-for="(banner, indextr) in data">

              <vs-td :data="data[indextr].title">
                {{ banner.title }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ banner.description }}
              </vs-td>

              <vs-td :data="data[indextr].inUse">
                <vs-chip class="ml-auto" color="success" v-if="banner.inUse">Active</vs-chip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <vx-card :title="editBanner ? `Update ${bannerObject.title}` : 'New Data Plan'" v-show="!bannerListVisable">
      <div class="vx-row">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full w-full">
          <div class="vx-col w-full mb-3">
            <label>Title</label>
            <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full" name="title"
              v-model="bannerObject.title" />
            <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row ">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full w-full">
          <label>Description</label>
          <vs-textarea autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"
            name="Description" v-model="bannerObject.description" />
          <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description')
          }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full w-full">
          <!-- Put FilePond Here -->
          <vs-radio v-model="bannerObject.imageUrl" vs-value="https://lateralscaffolding.blob.core.windows.net/digimarket/Group_1.png" color="success"><img class="digi-choose-image" src="https://lateralscaffolding.blob.core.windows.net/digimarket/Group_1.png" alt="Group_1"></vs-radio>
          <vs-radio v-model="bannerObject.imageUrl" vs-value="https://lateralscaffolding.blob.core.windows.net/digimarket/Group_2.png" color="success"><img class="digi-choose-image" src="https://lateralscaffolding.blob.core.windows.net/digimarket/Group_2.png" alt="Group_2"></vs-radio>
          <vs-radio v-model="bannerObject.imageUrl" vs-value="https://lateralscaffolding.blob.core.windows.net/digimarket/Group_3.png" color="success"><img class="digi-choose-image" src="https://lateralscaffolding.blob.core.windows.net/digimarket/Group_3.png" alt="Group_3"></vs-radio>
        </div>
      </div>
      <div class="vx-row mobileMarginTop-2">
        <div class="vx-col sm:w-1/3 w-full">
          <vs-checkbox v-model="bannerObject.inUse" color="success">Active</vs-checkbox>
        </div>
      </div>
      <div class="vx-row w-full btn-container-float-end">
        <vs-button :disabled="!isAllItemsFilled" color="success" class="vx-col   " @click="addOrEditHandler">{{editBanner ? 'Update':'Add'}}</vs-button>
        <vs-button color="warning" type="border" class="vx-col  " @click="cancel" >Cancel</vs-button>
      </div>
    </vx-card>
  </div>
</template> 


<script>
import 'animate.css';
export default {
  data() {
    return {
      banners: [],
      bannerListVisable: true,
      criteria: {
        pageSize: 10,
        pageNumber: 1,
      },
      editBanner: false,
      bannerObject: {
        id: 0,
        title: "",
        description: "",
        imageUrl: "",
        inUse: false,
      },
      isAllItemsFilled: true,
    }
  },
  components: {

  },
  watch: {
    bannerObject: {
      handler: function (value) {
        var self = this;
        this.$validator.validateAll().then(result => { self.isAllItemsFilled = (result && value.imageUrl ? true: false)})
      },
      deep: true
    },
  },
  computed: {

  },
  methods: {
    init() {
      this.bannerListVisable = true;
      this.editBanner = false;
      this.bannerObject= {
        id: 0,
        title: "",
        description: "",
        imageUrl: "",
        inUse: false,
      }
    },
    getBanners() {
      var self = this;
      self.showLoadingOnElement("bannerTable", 1, "corners");
      var onSuccess = response => {
        self.banners = response.data;
      }

      var onFinally = response => {
        if (self.$refs.bannerTable) {
          self.$vs.loading.close(self.$refs.bannerTable.$el);
        }
      }
      self.$ajaxGet(self, "Admin/GetBanners", onSuccess, onFinally);
    },
    selectedBanner(banner) {
      this.bannerObject = JSON.parse(JSON.stringify(banner))
      this.bannerListVisable = false;
      this.editBanner = true;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    updateBanner() {
      var self = this;
      self.showLoadingOnElement("Banners", 1, "corners");
      var onSuccess = response => {
        self.getBanners();
      }

      var onFinally = response => {
        if (self.$refs.Banners) {
          self.$vs.loading.close(self.$refs.Banners.$el);
        }
        self.init();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Banner Updated",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-smartphone'
        });
      }

      self.$ajaxPost(self, "Admin/UpdateBannerData", this.bannerObject, onSuccess, onFinally);
    },
    addBanner() {
      var self = this;
      self.showLoadingOnElement("Banners", 1, "corners");
      var onSuccess = response => {
        self.getBanners();
      }

      var onFinally = response => {
        if (self.$refs.Banners) {
          self.$vs.loading.close(self.$refs.Banners.$el);
        }
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Banner Added",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-smartphone'
        });
        self.init();
      }

      self.$ajaxPost(self, "Admin/AddNewBannerData", this.bannerObject, onSuccess, onFinally);
    },
    validateDeleteBanner(){
      this.$swal({
        title: 'Are you sure',
        icon: 'info',
        html: `You are about to Delete <strong> ${this.bannerObject.title}</strong>.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-danger vs-button-filled',
          denyButton: 'vs-component vs-button vs-button-warning vs-button-border ml-2',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn',
        },
        buttonsStyling: false,
        showDenyButton: true,
        denyButtonText: `Cancel`,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.isConfirmed) { // <-- if confirmed
          this.deleteBanner();
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            html: `${this.bannerObject.title} has been deleted.`,
            customClass: {
            confirmButton: 'vs-component vs-button vs-button-success vs-button-filled',
            }
          })
        }
        else{
          this.$swal({
            icon: 'success',
            title: 'Canceled',
            html: `${this.bannerObject.title} has not been deleted.`,
            customClass: {
            confirmButton: 'vs-component vs-button vs-button-success vs-button-filled',
            }
          })
        }
      });
    },
    deleteBanner() {
      var self = this;
      self.showLoadingOnElement("Banners", 1, "corners");

      var onSuccess = response => {
        self.getBanners();
      }
      var onFinally = response => {
        if (self.$refs.Banners) {
          self.$vs.loading.close(self.$refs.Banners.$el);
        }
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Data Plan Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-smartphone'
        });
        self.init();
      }

      self.$ajaxGet(self, `Admin/DeleteBanner?bannerId=${this.bannerObject.id}`, onSuccess, onFinally);
    },
    cancel() {
      this.init();
    },
    addOrEditHandler(){
      if(this.editBanner){
        this.updateBanner();
      }
      else{
        this.addBanner();
      }
    },
    openAddNewBanner(){
      this.bannerListVisable = false;
      this.editBanner = false;
    }
  },
  mounted() {
    this.init();
    this.banners = [];
    this.getBanners();
  },
}
</script>


<style lang="scss">
.mobileMarginTop-2 {
  @media screen and (max-width:1024px) {
    margin-top: 15px;
  }
}
.btn-container-float-end{
  justify-content: end;
  button{
    margin: 5px;
  }
}
.digi-choose-image{
  height: 200px;
}
</style>